import _classCallCheck from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
export var Density = /*#__PURE__*/function () {
  function Density() {
    _classCallCheck(this, Density);

    this.enable = false;
    this.area = 800;
    this.factor = 1000;
  }

  _createClass(Density, [{
    key: "value_area",
    get: function get() {
      return this.area;
    },
    set: function set(value) {
      this.area = value;
    }
  }, {
    key: "load",
    value: function load(data) {
      var _a;

      if (data === undefined) {
        return;
      }

      if (data.enable !== undefined) {
        this.enable = data.enable;
      }

      var area = (_a = data.area) !== null && _a !== void 0 ? _a : data.value_area;

      if (area !== undefined) {
        this.area = area;
      }

      if (data.factor !== undefined) {
        this.factor = data.factor;
      }
    }
  }]);

  return Density;
}();